import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_FIELDS_ON_CARD_MENU,
  DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND,
  DARK_FIELDS_ON_CARD_TEXTBOX_BORDER,
  DARK_TEXT,
  ERROR_TEXTBOX_BORDER,
  LIGHT_MENUITEM_BACKGROUND,
  LIGHT_TEXTBOX_BACKGROUND,
  LIGHT_TEXTBOX_BORDER,
  PLAIN_TEXT,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    inputContainer: {
      marginTop: 25,
      display: 'flex',
      '& ul': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? `${DARK_FIELDS_ON_CARD_MENU} !important`
            : `${LIGHT_MENUITEM_BACKGROUND} !important`,
      },
      '& li:hover': {
        color: theme.palette.type === 'dark' ? `${DARK_TEXT} !important` : `${PLAIN_TEXT} !important`,
      },
      '& li.highlight': {
        color: theme.palette.type === 'dark' ? `${DARK_TEXT} !important` : `${PLAIN_TEXT} !important`,
      },
      '& input': {
        color: theme.palette.type === 'dark' ? `${PLAIN_TEXT}` : `${DARK_TEXT} !important`,
      },
      '& input:disabled': {
        opacity: '0.5',
      },
      width: '100%',
    },
    contactInput_class: {
      height: '50px !important',
      padding: '10px 16px 10px 0',
      fontSize: '14px !important',
      background:
        theme.palette.type === 'dark'
          ? `${DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND} !important`
          : `${LIGHT_TEXTBOX_BACKGROUND} !important`,
      caretColor: theme.palette.type === 'dark' ? `${PLAIN_TEXT} !important` : `${DARK_TEXT} !important`,
      borderRadius: '4px !important',
      border:
        theme.palette.type === 'dark'
          ? `solid 1px ${DARK_FIELDS_ON_CARD_TEXTBOX_BORDER} !important`
          : `solid 1px ${LIGHT_TEXTBOX_BORDER} !important`,
      width: '100% !important',

      '&.invalid-number': {
        border: '1px solid!important',
        borderColor: `${ERROR_TEXTBOX_BORDER} !important`,
      },
    },
    contactContainer_class: {
      '& .flag-dropdown.open, & .selected-flag, & .flag-dropdown': {
        background:
          theme.palette.type === 'dark'
            ? `${DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND} !important`
            : `${LIGHT_TEXTBOX_BACKGROUND} !important`,
        '&.invalid-number': {
          border: '1px solid!important',
          borderWidth: '1px 0 1px 1px!important',
          borderColor: `${ERROR_TEXTBOX_BORDER} !important`,
        },
      },

      '& .divider': {
        borderColor:
          theme.palette.type === 'dark'
            ? `${DARK_FIELDS_ON_CARD_TEXTBOX_BORDER} !important`
            : `${LIGHT_TEXTBOX_BACKGROUND} !important`,
      },
    },
    contactButton_class: {
      border:
        theme.palette.type === 'dark'
          ? `solid 1px ${DARK_FIELDS_ON_CARD_TEXTBOX_BORDER} !important`
          : `solid 1px ${LIGHT_TEXTBOX_BORDER} !important`,
      borderRight: 'none !important',
      borderTopLeftRadius: '4px !important',
      borderBottomLeftRadius: '4px !important',
      height: 'inherit !important',
      paddingLeft: '5px !important',
    },
    spanError: {
      color: theme.palette.error.main,
      marginTop: 3,
      marginLeft: 14,
      marginRight: 14,
      fontSize: '0.75rem',
    },
  }),
);
